import React from 'react';

const Section = ({ field, fieldFactory }) => (
  <fieldset className={field.model.cssClass}>{field.fields.map(fieldFactory)}</fieldset>
);

export default Section;
